// src\stores\reducers\todos.ts
// import { CONNECT_WALLET } from './../../constants';
// import { IWallet } from './../types'



// const wallet = (state: IWallet = {connected: 0}, action: { type: string; value: any }) => {
//   switch (action.type) {
//     case CONNECT_WALLET:
//       return  {
//         ...state,
//         ...action.value
//       };
//     default:
//       return state;
//   }
// };

// export default wallet;

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CONNECT_WALLET } from './../../constants';
import { IWallet } from './../types';

interface WalletState extends IWallet {
  connected: number;
}

const initialState: WalletState = {
  connected: 0
};

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    connectWallet: (state, action: PayloadAction<IWallet>) => {
      state.connected = action.payload.connected;
    }
  }
});

export const { connectWallet } = walletSlice.actions;

export default walletSlice;